(function () {
  "use strict";

  // Host page sets window.SWQ: { data: url of swq-data.json, api: base url of the Vercel API ("" = same
  // origin), resultUrl: where the result page lives }. Shopify sets these from the section's Liquid.
  var CFG = Object.assign({ data: "/swq-data.json", api: "", resultUrl: "/result.html" }, window.SWQ || {});
  var MAP = null;
  var stage = document.getElementById("swq-stage");
  var progressEl = document.getElementById("swq-progress");
  var qhead = document.getElementById("swq-qhead");

  // Loading/status states take over the question panel so the layout doesn't jump.
  function thinking(msg) {
    qhead.innerHTML = '<h2 class="swq-thinking">' + msg + "</h2>";
    stage.innerHTML = "";
  }

  var state = {
    sessionId: makeId(),
    answers: [],      // {question_id, prompt, answer_id, answer_text, points_to, weight, recommend, phase}
    asked: [],        // question objects already answered, in order (for Back)
    current: null,
    branch: null,     // archetype id once routed
    sharedIdx: 0,
    lastProbs: null,
    lastSource: null,
    utm: readUtm()
  };

  function makeId() {
    try { return crypto.randomUUID(); } catch (e) { return "s" + Date.now().toString(36) + Math.random().toString(36).slice(2, 8); }
  }

  function readUtm() {
    var out = {};
    var p = new URLSearchParams(location.search);
    ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid"].forEach(function (k) {
      if (p.get(k)) out[k] = p.get(k);
    });
    return out;
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function log(event, extra) {
    if (CFG.api === null) return; // no quiz API configured on this host
    // fbclid stays out of our logs: answers can include health details and must not be joinable to an ad click.
    var utm = Object.assign({}, state.utm);
    delete utm.fbclid;
    var payload = Object.assign({ event: event, session_id: state.sessionId, utm: utm }, extra || {});
    try {
      var body = JSON.stringify(payload);
      if (navigator.sendBeacon) {
        // text/plain keeps the cross-origin beacon free of a CORS preflight.
        navigator.sendBeacon(CFG.api + "/api/log", new Blob([body], { type: "text/plain" }));
      } else {
        fetch(CFG.api + "/api/log", { method: "POST", headers: { "Content-Type": "text/plain" }, body: body, keepalive: true })
          .catch(function (err) { console.warn("quiz log failed", err); });
      }
    } catch (err) {
      console.warn("quiz log failed", err);
    }
  }

  function track(name, params, custom) {
    // Meta pixel, only when an id is configured in quiz_map.json.
    if (window.fbq) window.fbq(custom ? "trackCustom" : "track", name, params || {});
  }

  function loadPixel(id) {
    if (!id) return;
    /* Standard Meta pixel bootstrap. */
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version="2.0";n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,"script","https://connect.facebook.net/en_US/fbevents.js");
    window.fbq("init", id);
    window.fbq("track", "PageView");
  }

  // ---------- classification ----------

  function localScore() {
    var scores = {};
    MAP.archetype_ids.forEach(function (id) { scores[id] = 0; });
    var total = 0;
    state.answers.forEach(function (a) {
      if (a.points_to && a.weight) { scores[a.points_to] += a.weight; total += a.weight; }
    });
    var probs = {};
    MAP.archetype_ids.forEach(function (id) { probs[id] = total ? scores[id] / total : 1 / MAP.archetype_ids.length; });
    return probs;
  }

  function topOf(probs) {
    var best = null;
    Object.keys(probs).forEach(function (k) { if (best === null || probs[k] > probs[best]) best = k; });
    return { id: best, p: probs[best] };
  }

  function classify(budgetMs) {
    var payload = {
      session_id: state.sessionId,
      answers: state.answers
        .map(function (a) { return { question_id: a.question_id, prompt: a.prompt, answer_text: a.answer_text, answer_id: a.answer_id }; })
    };
    if (CFG.api === null) return Promise.resolve({ source: "local", probs: localScore() });
    var ctrl = new AbortController();
    var t = setTimeout(function () { ctrl.abort(); }, budgetMs || 3000);
    return fetch(CFG.api + "/api/classify", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      signal: ctrl.signal
    }).then(function (r) {
      clearTimeout(t);
      if (!r.ok) throw new Error("classify " + r.status);
      return r.json();
    }).then(function (d) {
      // Keep only known archetype ids and normalize to sum to 1, so a surprise label or a
      // percentage scale from the API can never route someone to a branch that doesn't exist.
      var probs = {}, sum = 0;
      MAP.archetype_ids.forEach(function (id) {
        var v = Number((d.probabilities || {})[id]) || 0;
        probs[id] = v; sum += v;
      });
      if (!(sum > 0)) throw new Error("no usable probabilities");
      MAP.archetype_ids.forEach(function (id) { probs[id] = probs[id] / sum; });
      return { source: "jev", probs: probs };
    }).catch(function (err) {
      clearTimeout(t);
      console.info("Jev unavailable, using local scoring:", err.message);
      log("fallback", { answer_id: String(err.message).slice(0, 60) });
      return { source: "local", probs: localScore() };
    });
  }

  // ---------- flow ----------

  function nextQuestion() {
    if (state.branch) {
      var qs = MAP.branches[state.branch].questions;
      var answeredInBranch = state.answers.filter(function (a) { return a.phase === "branch"; }).length;
      return qs[answeredInBranch] || null;
    }
    return MAP.shared[state.sharedIdx] || null;
  }

  function plannedTotal() {
    var done = state.answers.length;
    if (state.branch) {
      var left = MAP.branches[state.branch].questions.length - state.answers.filter(function (a) { return a.phase === "branch"; }).length;
      return done + left;
    }
    // Still in shared phase: assume worst case (all shared + a full branch).
    var branchLen = MAP.branches[MAP.archetype_ids[0]].questions.length;
    return Math.max(MAP.shared.length + branchLen, done + 1);
  }

  function renderProgress() {
    var total = plannedTotal();
    var done = state.answers.length;
    var step = document.getElementById("swq-step");
    if (step) step.textContent = "Question " + (done + 1) + " of " + (state.branch ? "" : "about ") + total;
    progressEl.style.setProperty("--swq-pct", Math.round(100 * done / total) + "%");
    var html = "";
    for (var i = 0; i < total; i++) html += '<span class="' + (i < done ? "on" : "") + '"></span>';
    progressEl.innerHTML = html;
  }

  function render(q) {
    state.current = q;
    state.busy = false;
    renderProgress();
    // The intro note only matters on the first question; hiding it later keeps answers above the fold.
    var note = document.querySelector(".swq-panel-note");
    if (note) note.hidden = state.answers.length > 0;
    var back = state.asked.length ? '<button class="swq-back" id="swq-back" type="button">&larr; Back</button>' : "";
    if (q.type === "single") {
      var opts = q.options.map(function (o) {
        return '<button class="swq-opt" type="button" data-id="' + esc(o.id) + '">' + esc(o.label) + "</button>";
      }).join("");
      qhead.innerHTML = '<div class="swq-q">' + back + "<h2>" + esc(q.prompt) + "</h2>" +
        (q.helper ? '<p class="swq-helper">' + esc(q.helper) + "</p>" : "") + "</div>";
      stage.innerHTML = '<div class="swq-q swq-opts">' + opts + "</div>" +
        (state.answers.length === 0 ? '<div class="swq-note">No wrong answers. This just tells us which pair to show you.</div>' : "");
      Array.prototype.forEach.call(stage.querySelectorAll(".swq-opt"), function (btn) {
        btn.addEventListener("click", function () {
          if (state.busy) return;
          state.busy = true;
          var opt = q.options.filter(function (o) { return o.id === btn.dataset.id; })[0];
          btn.classList.add("sel");
          Array.prototype.forEach.call(stage.querySelectorAll(".swq-opt"), function (b) { b.disabled = true; });
          setTimeout(function () { answer(q, opt, opt.label); }, 220);
        });
      });
    }
    var b = document.getElementById("swq-back");
    if (b) b.addEventListener("click", goBack);
    window.scrollTo(0, 0);
  }

  function goBack() {
    if (!state.asked.length) return;
    var q = state.asked.pop();
    var a = state.answers.pop();
    // Analysis drops answers that were later taken back.
    log("back", { question_id: q.id, answer_id: a.answer_id });
    if (a.phase === "shared") {
      state.branch = null;
      state.sharedIdx = MAP.shared.indexOf(q);
    }
    // Backing out within the branch keeps the branch: the shared answers decided it.
    render(q);
  }

  function answer(q, opt, text) {
    var phase = state.branch ? "branch" : "shared";
    state.answers.push({
      question_id: q.id,
      prompt: q.prompt,
      answer_id: opt.id,
      answer_text: text,
      points_to: opt ? opt.points_to : null,
      weight: opt && phase === "shared" ? (opt.weight !== undefined ? opt.weight : 1) : 0,
      recommend: opt ? opt.recommend : null,
      body: opt && opt.body !== undefined ? opt.body : undefined,
      pick: !!(opt && opt.pick),
      phase: phase
    });
    state.asked.push(q);
    if (phase === "shared") state.sharedIdx++;

    var answerId = opt.id;
    function logAnswer(res) {
      state.lastProbs = res.probs;
      state.lastSource = res.source;
      log("answer", {
        question_id: q.id, answer_id: answerId,
        probabilities: res.probs, source: res.source
      });
    }

    // Routing only needs the classifier at decision points: after s2 and later shared answers.
    // Everywhere else, move on immediately and classify in the background for the log.
    var decisionPoint = phase === "shared" && state.sharedIdx >= 2;
    if (!decisionPoint && nextQuestion()) {
      classify().then(logAnswer);
      advance();
      return;
    }
    if (!decisionPoint) {
      // Last question: wait for the classifier so the final answer is logged before we leave the page.
      thinking("Finding your pair&hellip;");
      classify().then(logAnswer).then(advance, advance);
      return;
    }

    thinking("Consulting the waistband council&hellip;");
    classify(5000).then(function (res) {
      logAnswer(res);
      var top = topOf(res.probs);
      var threshold = res.source === "jev" ? MAP.routing.branch_threshold : MAP.routing.local_branch_threshold;
      var sharedLeft = state.sharedIdx < MAP.shared.length;
      if (top.p > threshold || !sharedLeft) {
        state.branch = top.id;
        log("branch", { archetype: top.id, probabilities: res.probs, source: res.source, question_id: q.id });
      }
      advance();
    }).catch(function (err) {
      // Never leave someone stuck on the loading screen.
      console.error("routing failed, using local scoring", err);
      if (!state.branch && state.sharedIdx >= MAP.shared.length) state.branch = topOf(localScore()).id;
      advance();
    });
  }

  function advance() {
    var nq = nextQuestion();
    if (nq) render(nq); else finish();
  }

  function bodyPick() {
    var picked = null;
    state.answers.forEach(function (a) { if (a.body !== undefined) picked = a.body; });
    return picked;
  }

  function finish() {
    var rec = null;
    state.answers.forEach(function (a) { if (a.recommend) rec = a.recommend; });
    rec = rec || MAP.default_recommendation[state.branch];
    var body = bodyPick();
    log("complete", { archetype: state.branch, product: rec, probabilities: state.lastProbs, source: state.lastSource, body: body });
    track("Lead", { content_category: state.branch });
    // Echo their waistband complaint (s2) back on the result page.
    var said = state.answers.filter(function (a) { return a.question_id === "s2"; })[0];
    // Personal details (their own words, body considerations) go through sessionStorage, never the URL,
    // because page URLs are sent to the Meta pixel and other analytics.
    try {
      sessionStorage.setItem("swq_result_" + state.sessionId, JSON.stringify({
        said: said ? said.answer_text.slice(0, 220) : null,
        body: body || null,
        pick: state.answers.some(function (a) { return a.pick; })
      }));
    } catch (e) { console.info("sessionStorage unavailable", e); }
    var p = new URLSearchParams(state.utm);
    p.set("a", state.branch);
    p.set("p", rec);
    p.set("qsid", state.sessionId);
    thinking("Found them. One second&hellip;");
    var url = CFG.resultUrl + (CFG.resultUrl.indexOf("?") === -1 ? "?" : "&") + p.toString();
    setTimeout(function () { location.href = url; }, 350);
  }

  // ---------- boot ----------

  // Data ships as a script that sets window.SWQ_DATA (Shopify's CDN won't serve .json theme assets).
  var dataReady = window.SWQ_DATA ? Promise.resolve(window.SWQ_DATA) : fetch(CFG.data).then(function (r) {
    if (!r.ok) throw new Error("quiz data " + r.status);
    return r.json();
  });
  dataReady.then(function (m) {
    MAP = m.quiz;
    // On Shopify the store's own pixel is already on the page (CFG.hostPixel), so don't load a second copy.
    if (!CFG.hostPixel) loadPixel((MAP.tracking || {}).meta_pixel_id);
    log("quiz_start", {});
    track("ViewContent", { content_name: "archetype_quiz" });
    render(MAP.shared[0]);
  }).catch(function (err) {
    console.error("Quiz failed to load", err);
    thinking('The quiz tripped over its own straps. <a href="/collections/all">Shop Swoveralls instead</a>.');
  });
})();
